export const VIEW_IMG = 'VIEW_IMG';
export const VIEW_IMG2 = 'VIEW_IMG2';
export const LIVE_LIST_VIEW = 'LIVE_LIST_VIEW';
export const CONCERN_LIST_VIEW = 'CONCERN_LIST_VIEW';
export const CLASSIFY = 'CLASSIFY';
export const LIVE_MANAGE_VIEW = 'LIVE_MANAGE_VIEW';
export const SET_MAJOR_STATUS = 'SET_MAJOR_STATUS';
export const SET_CHOOSETYPE_STATUS = 'SET_CHOOSETYPE_STATUS';
export const SET_PRICETYPE_STATUS = 'SET_PRICETYPE_STATUS';
export const SET_ACTIVITYID_STATUS = 'SET_ACTIVITYID_STATUS';
export const SET_MAJOR_COUNT = 'SET_MAJOR_COUNT';
export const SET_MAJOR_TOTAL = 'SET_MAJOR_TOTAL';
export const SET_MAJOR_FROMTYPE = 'SET_MAJOR_FROMTYPE';
export const SET_MAJOR_TYPE = 'SET_MAJOR_TYPE';
export const SET_MAJOR_EMPTY = 'SET_MAJOR_EMPTY';
export const SET_CURRENT_ACTIVE = 'SET_CURRENT_ACTIVE';
export const SET_VOTE_STATUS = 'SET_VOTE_STATUS';
export const SET_VOTE_LUCK = 'SET_VOTE_LUCK';
export const SET_VOTE_CURROW = 'SET_VOTE_CURROW';
export const SET_INVOICE_PAGE = 'SET_INVOICE_PAGE';
export const CHANGE_FORM_DATA_STATUS = 'CHANGE_FORM_DATA_STATUS';
export const SET_SHOW_MAJOR = 'SET_SHOW_MAJOR';
export const SET_LEFT_SLIDE = 'SET_LEFT_SLIDE';
export const SET_CREATED_STATUS = 'SET_CREATED_STATUS';
export const STREAMING_STATUS = 'STREAMING_STATUS';
export const UPDATED_LIVE_DATA = 'UPDATED_LIVE_DATA';
export const SET_NOTICE_ACTIVE = 'SET_NOTICE_ACTIVE';
export const SET_LIVE_CONTENT = 'SET_LIVE_CONTENT';
export const SET_NOT_READ_MSG_NUM = 'SET_NOT_READ_MSG_NUM';
export const SET_NOTICE_PAGE = 'SET_NOTICE_PAGE';
export const SET_NOTICE_ID = 'SET_NOTICE_ID';
export const SET_ACTIVITY_BGM = 'SET_ACTIVITY_BGM';
export const SET_LIST_LUCK = 'SET_LIST_LUCK';
export const SET_IS_OURWILL_DOMAIN = 'SET_IS_OURWILL_DOMAIN';
export const SET_ACTIVITY_DOMAIN = 'SET_ACTIVITY_DOMAIN';
